export default {
  // Stubs - DevTools expects to find these methods and replace them
  // with wrappers in order to observe components being mounted, updated and
  // unmounted
  mountComponent() {},
  receiveComponent() {},
  unmountComponent() {},
  // Stub - DevTools expects to find this method and replace it
  // with a wrapper in order to observe new root components being added
  renderNewRootComponent() {},
};
